import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var RateStyle = function RateStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    lineColor1 = _getThemeData.lineColor1,
    warningColor = _getThemeData.warningColor;
  return css([".c7n-rate.c7n-rate{color:", ";.c7n-rate-star-first,.c7n-rate-star-second{color:", ";}.c7n-rate-star-half .c7n-rate-star-first,.c7n-rate-star-full .c7n-rate-star-second{color:inherit;}}"], warningColor, lineColor1);
};
export default RateStyle;